export const internalUserPreferenceKeys = {
  gridDevTools: "gdt",
  invoiceUpload: "invoice-upload",
  viewedAssistant: "viewed-assistant",
  graphqlNoBatching: "graphql-no-batching",
  vTables: "virtual-tables",
  usingAdyen: "using-adyen",
}

export const userPreferenceKeys = {
  expandedView: "expanded-view",
  editLedger: "edit-ledger",
  vaultListView: "vault-list-view",
}
